<template>
	<div>
		<SearchBanner />
		<VSheet class="search-content d-flex flex-column align-center pb-2 pt-4 pb-md-4 pt-md-8 px-2">
			<div class="d-flex flex-column">
				<h2
					class="search-info mt-2 mt-md-0 mx-md-0 mb-4 mb-md-6 mx-4"
					:class="isMobile ? 'text-body-2' : 'text-h5'"
				>
					Saisissez une adresse et un code postal pour trouver la pharmacie la plus proche.
				</h2>
				<SearchAddressInput
					@change="redirectToResult"
				/>
			</div>
		</VSheet>
		<PageContainer
			size="s"
			spacing="ma-0"
			class="h-100 px-2"
		>
			<VSheet class="d-flex flex-column mt-10 mt-md-12 mb-6">
				<h2 class="primary--text">
					Les pharmacies de garde
				</h2>
				<h3>
					pour les besoins urgents d'accès aux médicaments et dispositifs médicaux
				</h3>
				<ul>
					<li>
						Elles assurent un accès aux médicaments en dehors des heures habituelles d'ouverture.
					</li>
					<li>
						Elles répondent aux besoins urgents suite à une prescription médicale.
					</li>
				</ul>
			</VSheet>
			<VSheet class="d-flex flex-column mt-10 mt-md-12 mb-6 mb-md-16">
				<h2 class="primary--text">
					Les informations disponibles varient
				</h2>
				<h3>
					en fonction de la plage horaire de garde
				</h3>
				<VCard
					class="mt-2 info-card"
					elevation="2"
					outlined
				>
					<VTabs
						v-model="tab"
						background-color="#E7ECF5"
						centered
						grow
						slider-size="1"
						active-class="elevation-2 active"
					>
						<VTab href="#tab-1">
							<VIcon
								color="yellow"
								class="mr-2"
							>
								{{ sun }}
							</VIcon>
							Garde de jour
						</VTab>

						<VTab href="#tab-2">
							<VIcon
								color="yellow"
								class="mr-2"
							>
								{{ moon }}
							</VIcon>
							Garde de nuit
						</VTab>
					</VTabs>

					<VTabsItems
						v-model="tab"
						class="text-body-1"
					>
						<VTabItem
							key="1"
							value="tab-1"
						>
							<VCard flat>
								<VCardText>
									<ul>
										<li><strong>Les dimanches et jours fériés,</strong> généralement entre 8h et 20h.</li>
										<li><strong>Liste des pharmacies de garde,</strong> mise à jour en temps réel pour tenir compte des informations de dernière minute.</li>
									</ul>
								</VCardText>
							</VCard>
						</VTabItem>
						<VTabItem
							key="2"
							value="tab-2"
						>
							<VCard flat>
								<VCardText>
									<ul>
										<li><strong>De nuit, l'information mise en ligne est limitée</strong> dans presque tous les départements pour des raisons de sécurité.</li>
										<li>Les coordonnées des pharmacies de garde de nuit ne sont pas disponibles sur ce service.</li>
									</ul>
								</VCardText>
							</VCard>
						</VTabItem>
					</VTabsItems>
				</VCard>
			</VSheet>
		</PageContainer>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import SearchBanner from '@/components/SearchBanner';
	import SearchAddressInput from '@/components/SearchAddressInput';

	import { AddressData } from '@/types';

	import { mdiWeatherNight, mdiWhiteBalanceSunny } from '@mdi/js';

	@Component({
		components: {
			SearchBanner,
			SearchAddressInput
		}
	})
	export default class Home extends Vue {
		tab = null;

		sun = mdiWhiteBalanceSunny;

		moon = mdiWeatherNight;

		get isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}

		redirectToResult(address: AddressData): void {
			this.$store.dispatch('addressData/updateAddress', address);

			this.$router.push({ name: 'result' });
		}
	}
</script>

<style lang="scss" scoped>
	h2 {
		font-size: 1.125rem;
	}
	h3 {
		font-size: 1rem;
	}

	li {
		font-size: .875rem;
		color: black;
	}
	.search-content {
		background-color: #E7ECF5;
	}

	.v-tab {
		text-transform: none;
	}

	.search-address-input {
		width: 600px !important;
	}

	.search-info {
		text-transform: none !important;
		max-width: 600px;
	}

	.info-card::v-deep .v-slide-group__prev {
		display: none !important;
	}
	.active {
		background-color: #F8F9FC;
	}
</style>
